/**
 * Manifest Switcher - Bascule dynamiquement entre les manifests PWA
 *
 * Permet d'avoir deux PWAs distinctes (Touriste vs Organisateur)
 * en changeant le lien manifest selon la route actuelle.
 */

const MANIFEST_TOURIST = '/manifest.json';
const MANIFEST_ORGANIZER = '/manifest-organizer.json';

/**
 * Detecte si on est sur une route organisateur
 */
export const isOrganizerRoute = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.pathname.startsWith('/organizer');
};

/**
 * Met a jour le lien manifest dans le head
 */
export const updateManifestLink = (manifestUrl: string): void => {
  const existingLink = document.querySelector('link[rel="manifest"]');

  if (existingLink) {
    existingLink.setAttribute('href', manifestUrl);
  } else {
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = manifestUrl;
    document.head.appendChild(link);
  }
};

/**
 * Initialise le manifest switcher
 * A appeler au demarrage de l'app et lors des changements de route
 */
export const initManifestSwitcher = (): void => {
  const manifest = isOrganizerRoute() ? MANIFEST_ORGANIZER : MANIFEST_TOURIST;
  updateManifestLink(manifest);
};

/**
 * Hook effect pour les changements de route
 * Retourne une fonction cleanup
 */
export const setupManifestWatcher = (): (() => void) => {
  // Initial setup
  initManifestSwitcher();

  // Ecouter les changements d'URL (popstate pour back/forward)
  const handleRouteChange = () => {
    initManifestSwitcher();
  };

  window.addEventListener('popstate', handleRouteChange);

  // Observer les changements de pathname via pushState/replaceState (pour wouter)
  const originalPushState = window.history.pushState.bind(window.history);
  const originalReplaceState = window.history.replaceState.bind(window.history);

  window.history.pushState = (...args: Parameters<typeof window.history.pushState>) => {
    originalPushState(...args);
    handleRouteChange();
  };

  window.history.replaceState = (...args: Parameters<typeof window.history.replaceState>) => {
    originalReplaceState(...args);
    handleRouteChange();
  };

  // Cleanup
  return () => {
    window.removeEventListener('popstate', handleRouteChange);
    window.history.pushState = originalPushState;
    window.history.replaceState = originalReplaceState;
  };
};
